module.exports = __webpack_public_path__ + "img/20.eaba4f25.png";